export default class BackgroundStatic {
    constructor(game, color) {
        this.game = game
        this.x = 0
        this.y = 0
        this.height = game.height
        this.width = game.width
        this.color = color
        this.image = document.getElementById('backgroundStatic')
    }

    draw(context) {
        //context.globalAlpha = 1
        //context.fillStyle = this.color;
        //context.fillRect(this.x, this.y, this.width, this.height)
        context.globalAlpha = 1
        context.drawImage(this.image, this.x, this.y, this.width, this.height)
    }
}